<template>
  <index-new-page v-if="isNewPage" />
  <index-old-page v-else />
  <div class="qrcode-wrap">
    <img
      class="qrcode"
      src="https://qzonestyle.gtimg.cn/qz-proj/weishi-pc/img/qrcode.png"
    >
    <p class="txt">
      下载客户端
    </p>
  </div>
</template>
<script lang="ts" setup>
import { onMounted, computed } from 'vue';
import useProvideBrowserInfo from '@/composable/use-provide-browser-info';
import useProvideUrlInfo from '@/composable/use-provide-url-info';
import useProvideCookieInfo from '@/composable/use-provide-cookie-info';
import useGetTabExperiment from '@/composable/use-get-tab-experiment';
import { useStore } from '@/store/index';
import IndexNewPage from './index_new.vue';
import IndexOldPage from './index_old.vue';

const { provideInfo: provideUrlInfo, info: urlInfo } = useProvideUrlInfo();
const { provideInfo: provideBrowserInfo } = useProvideBrowserInfo();
const { provideInfo: provideCookieInfo } = useProvideCookieInfo();

const { getTabExp } = useGetTabExperiment();

const store = useStore();
const { state } = store;
const isNewPage = computed(() => state.isNewPage || urlInfo.query?.isNew === '1');

// 提供cookie相关信息
provideCookieInfo();
// 提供浏览器平台相关信息
provideBrowserInfo();
// 提供当前页面链接上的相关信息
provideUrlInfo();

onMounted(async () => {
  await getTabExp(state.banner?.person?.uid || '');
});
</script>

<style lang="scss">
.qrcode-wrap {
  position: absolute;
  @include responsiveStyleSingle(top, 20, "px");
  right: 50%;
  @include responsiveStyleSingle(margin-right, -515, "px");
}

.qrcode {
  @include responsiveStyleSingle(width, 120, "px");
  @include responsiveStyleSingle(height, 120, "px");
}

.qrcode-wrap .txt {
  text-align: center;
  color: rgba(255, 255, 255, 0.6);
  @include responsiveStyleSingle(line-height, 25, "px");
  @include responsiveStyleSingle(margin-top, 9, "px");
  @include responsiveStyleSingle(font-size, 14, 'px');
}
</style>
